// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import { alertView } from '@/assets/js/alert'
import { comview } from '@/assets/js/common'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import $ from 'jquery'

Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
Vue.use(VideoPlayer);

Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.alertView = alertView
Vue.prototype.comview = comview
const testBaseUrl = 'http://pddzdtest.junchenlun.com/exam/Public/testexam/'
const officialBaseUrl = 'https://exam.junchenlun.com/testexam/'
if (process.env.NODE_ENV === 'development') {
  // 开发环境
  Vue.prototype.HOME = testBaseUrl
  // 生产环境
} else if (process.env.NODE_ENV === 'production') {
  const host = location.host
  const baseUrl = host === 'pddzdtest.junchenlun.com' ? testBaseUrl : officialBaseUrl
  Vue.prototype.HOME = baseUrl //这里是线上api请求地址
}

Vue.prototype.typeClass = [
  {
    label: "全部",
    value: 0,
  },
  {
    label: "考试系统",
    value: 1,
  },
  {
    label: "君臣论-经验课",
    value: 2,
  },
]
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js